module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/GlobalReachLogo-991205a1e25d768a0ab36184424dbb4d.jpg";